import React from 'react';
import { connect } from 'react-redux';
import { Form, Select, Input, Button } from 'antd';
import AddUserWrapper from './AddUser.style';
import { addNewUser, fetchAllUsers } from '../../../redux/actions/Users/UsersActions';

const FormItem = Form.Item;
const Option = Select.Option;

class AddUserForm extends React.Component {
  
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchAllUsers();
  }

  handleSubmit = (e) => {
    console.log(e.target);
    e.preventDefault();
    e.target.reset();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        this.props.addNewUser(values.email, values.role);
      }
      else {
        console.log(err);
      }
    });
  }
  
  render() {
    
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
    };
    
    return(
      <AddUserWrapper>

        <Form onSubmit={this.handleSubmit}>
        
          <FormItem
            {...formItemLayout}
            label="Email"
            hasFeedback>
            {getFieldDecorator('email', {
              rules: [
                { required:true , message: 'Please enter an E-Mail ID!' },
                { validator: (rule, value, cb) => value && value.split('@')[1] === 'mordorintelligence.com' ? cb() : cb(true), message: 'Please enter a mordorintelligence.com E-Mail ID!' },
                { validator: (rule, value, cb) => this.props.USERSREDUCER.all_users.filter(user => user.email === value).length === 0 ? cb() : cb(true), message: 'A user with this E-Mail ID already exists!' }
              ],
            })(
              <Input type="email" placeholder="Enter E-Mail ID" />
            )}
          </FormItem>
        
          <FormItem
            {...formItemLayout}
            label="Role"
            hasFeedback
          >
            {getFieldDecorator('role', {
              rules: [
                { required: true, message: 'Please select your role!' },
              ],
            })(
              <Select placeholder="Please select a role">
                <Option value="ADMIN">ADMIN</Option>
                <Option value="NONADMIN">NON-ADMIN</Option>
                <Option value="SALES">SALES</Option>
              </Select>
            )}
          </FormItem>

          <FormItem
            wrapperCol={{ span: 12, offset: 6 }}
          >
            <Button type="primary" htmlType="submit" loading={this.props.USERSREDUCER.add_user.addingUserStatus}>Add User</Button>
          </FormItem>

        </Form>
      </AddUserWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  addNewUser,
  fetchAllUsers
}

const AddUser = Form.create()(AddUserForm);

export default connect (mapStateToProps, mapDispatchToProps)(AddUser);


// WEBPACK FOOTER //
// ./src/components/Users/AddUser/AddUser.js